export const ALL_SPRINT_TASK_REQUEST = "allSprintTask/allSprintTaskRequest";
export const ALL_SPRINT_TASK_SUCCESS = "allSprintTask/allSprintTaskSuccess";
export const ALL_SPRINT_TASK_ERROR = "allSprintTask/allSprintTaskError";